// Created a consolidated version of the change-case capitalCase function since mobx thinks that change-case somehow
// mutates observables passed to it. This is not the case, but to avoid the error, we can use this function instead.

export function capitalCase(input: string): string {
    if (typeof input !== "string") {
        return input;
    }

    const result = input.trim()
        .replace(/([\p{Ll}\d])(\p{Lu})/gu, "$1\0$2")
        .replace(/(\p{Lu})(\p{Lu}\p{Ll})/gu, "$1\0$2")
        .replace(/[^\p{L}\d]+/giu, "\0");

    let start = 0;
    let end = result.length;

    while (result.charAt(start) === "\0") {
        start++;
    }

    let words = [];

    if (start !== end) {
        while (result.charAt(end - 1) === "\0") {
            end--;
        }
        words = result.slice(start, end).split(/\0/);
    }

    return (
        words
            .map((word: string) => `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`)
            .join(" ")
    );
}


// WEBPACK FOOTER //
// ./src/utils/capitalCase.ts